import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  FontAwesomeModule,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import {
  faCube,
  faSignOutAlt,
  faSitemap,
  faTools,
} from '@fortawesome/free-solid-svg-icons';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CardLayoutComponent } from './card-layout.component';

@NgModule({
  imports: [CommonModule, FontAwesomeModule, RouterModule],
  declarations: [HeaderComponent, FooterComponent, CardLayoutComponent],
  exports: [HeaderComponent, FooterComponent, CardLayoutComponent],
})
export class ComponentsModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      // Solid
      faCube,
      faSignOutAlt,
      faSitemap,
      faTools
    );
  }
}
